<template>
  <div class="card-filter">
    <el-row
      type="flex"
      align="start"
      justify="space-between"
      class="flex-wrap mb-l gap-12"
    >
      <el-row
        type="flex"
        align="middle"
      >
        <el-select
          v-model="type"
          size="medium"
          class="w-100 mr-m"
          placeholder="Danh mục"
          filterable
          @change="searchNormal"
        >
          <el-option
            v-for="item in categories"
            :key="item.id"
            :label="item.extra.name"
            :value="item.extra.key"
          />
        </el-select>
        <el-input
          v-model="textSearch"
          class="text-search mr-m"
          size="medium"
          placeholder="Nhập thông tin để tìm kiếm"
          clearable
        />
        <el-button
          size="medium"
          type="primary"
          plain
          icon="el-icon-search"
          @click="searchNormal"
        >
          Tìm kiếm
        </el-button>
      </el-row>
    </el-row>
  </div>
</template>

<script>

export default {
  name: "CardFilter",
  props: {
    categoryType: String,
    categories: Array
  },
  data() {
    return {
      textSearch: "",
      type: this.categoryType,
    };
  },
  methods: {
    searchNormal() {
      this.$emit("search", {
        type: this.type,
        searchText: this.textSearch,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-filter {
  .text-search {
    min-width: 200px;
  }
}
</style>
